<template>
  <div id="contents">
    <div id="main">
      <div class="blog">
        <section>
          <div v-if="displayItems.length">
            <div v-for="blogPost in displayItems" :key="blogPost.id">
              <h2 class="mb-1">{{ blogPost.title }}</h2>
              <div class="mb-0 text-right small align-middle mr-2">
                {{ blogPost.date | moment }}
              </div>
              <div
                class="pl-4"
                v-html="$options.filters.fixParagraphText(blogPost.content)"
              ></div>
              <h5 class="pl-4 mb-5 mt-3">
                <span
                  class="badge badge-info mr-1"
                  v-for="tag in blogPost.tag"
                  :key="tag"
                >
                  {{ tag }}
                </span>
              </h5>
            </div>
          </div>
          <div v-else>
            <div>記事を探しています...</div>
          </div>
        </section>

        <nav class="paginate text-center">
          <ul class="pagination">
            <li class="page-item">
              <a @click="first" class="page-link" href="#">&laquo;</a>
            </li>
            <li class="page-item">
              <a @click="prev" class="page-link" href="#">&lt;</a>
            </li>
            <li
              v-for="i in displayPageRange"
              v-bind:key="i"
              class="page-item"
              :class="{ active: i - 1 === currentPage }"
            >
              <a @click="pageSelect(i)" class="page-link" href="#">{{ i }}</a>
            </li>
            <li class="page-item">
              <a @click="next" class="page-link" href="#">&gt;</a>
            </li>
            <li class="page-item">
              <a @click="last" class="page-link" href="#">&raquo;</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <!--/main-->
    <sub-menu-list />
  </div>
  <!--/contents-->
</template>

<script>
import moment from "moment";
import SubMenuList from "@/components/SubMenuList";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default {
  components: {
    "sub-menu-list": SubMenuList,
  },
  data() {
    return {
      currentPage: 0, // 現在のページ番号
      size: 5, // 1ページに表示するアイテムの上限
      pageRange: 5, // ページネーションに表示するページ数の上限
      items: [], // 表示するアイテムリスト
    };
  },
  mounted() {
    // 表示するアイテムの初期化（APIで取得するなど）
    this.items = [...Array(200)].map((_, i) => {
      return {
        text: `Item: ${i}`,
      };
    });
  },
  computed: {
    contentList() {
      return this.$store.getters.getContentListBlog;
    },
    blogPosts() {
      if (!("postDate" in this.$route.params)) {
        return this.$store.getters.getBlogPosts;
      }

      var toDoubleDigits = function(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
        return num;
      };

      const postDate = this.$route.params.postDate;
      const argLength = postDate.length;
      const blogPosts = this.$store.getters.getBlogPosts.filter(
        function(content) {
          let dateTime = new Date(content.date);
          var yyyy = dateTime.getFullYear();
          var mm = toDoubleDigits(dateTime.getMonth() + 1);
          var dd = toDoubleDigits(dateTime.getDate());
          var dateNumber = "";
          if (argLength == 4) {
            // YYYY
            dateNumber = yyyy;
          } else if (argLength == 6) {
            // YYYYMM
            dateNumber = "" + yyyy + mm;
          } else if (argLength == 8) {
            // YYYYMMDD
            dateNumber = "" + yyyy + mm + dd;
          } else {
            // パラメータ不正
            return false;
          }
          console.log(dateNumber);
          if (dateNumber == postDate) {
            console.log(" => OK!!!");
          }

          return dateNumber == postDate;
        },
        postDate,
        argLength
      );
      console.log(postDate);
      console.log(blogPosts);

      return blogPosts;
    },
    /**
     * ページ数を取得する
     * @return {number} 総ページ数(1はじまり)
     */
    pages() {
      return Math.ceil(this.blogPosts.length / this.size);
    },
    /**
     * ページネーションで表示するページ番号の範囲を取得する
     * @return {Array<number>} ページ番号の配列
     */
    displayPageRange() {
      const half = Math.ceil(this.pageRange / 2);
      let start, end;

      if (this.pages < this.pageRange) {
        // ページネーションのrangeよりページ数がすくない場合
        start = 1;
        end = this.pages;
      } else if (this.currentPage < half) {
        // 左端のページ番号が1になったとき
        start = 1;
        end = start + this.pageRange - 1;
      } else if (this.pages - half < this.currentPage) {
        // 右端のページ番号が総ページ数になったとき
        end = this.pages;
        start = end - this.pageRange + 1;
      } else {
        // activeページを中央にする
        start = this.currentPage - half + 1;
        end = this.currentPage + half;
      }

      let indexes = [];
      for (let i = start; i <= end; i++) {
        indexes.push(i);
      }
      return indexes;
    },
    /**
     * 現在のページで表示するアイテムリストを取得する
     * @return {any} 表示用アイテムリスト
     */
    displayItems() {
      const head = this.currentPage * this.size;
      return this.blogPosts.slice(head, head + this.size);
    },
    /**
     * 現在のページかどうか判定する
     * @param {number} page ページ番号
     * @return {boolean} 現在のページならtrue
     */
    isSelected(page) {
      return page - 1 === this.currentPage;
    },
  },
  methods: {
    /**
     * ページ先頭に移動する
     */
    first() {
      this.currentPage = 0;
      this.selectHandler();
    },
    /**
     * ページ後尾に移動する
     */
    last() {
      this.currentPage = this.pages - 1;
      this.selectHandler();
    },
    /**
     * 1ページ前に移動する
     */
    prev() {
      if (0 < this.currentPage) {
        this.currentPage--;
        this.selectHandler();
      }
    },
    /**
     * 1ページ次に移動する
     */
    next() {
      if (this.currentPage < this.pages - 1) {
        this.currentPage++;
        this.selectHandler();
      }
    },
    /**
     * 指定したページに移動する
     * @param {number} index ページ番号
     */
    pageSelect(index) {
      this.currentPage = index - 1;
      this.selectHandler();
    },
    /**
     * ページを変更したときの処理
     */
    selectHandler() {
      // なんかの処理
    },
  },
  filters: {
    addComma: function(value) {
      return value.toLocaleString();
    },
    addNewLine: function(value) {
      return value.replace(/\r?\n/g, "<br>");
    },
    convertBullet: function(value) {
      return "<ul><li>" + value.replace(/\r?\n/g, "</li><li>") + "</li></ul>";
    },
    formatDate: function(value) {
      return "<ul><li>" + value.replace(/\r?\n/g, "</li><li>") + "</li></ul>";
    },
    moment: function(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    resizeImage: function(value) {
      value = value.replace(/<img/g, '<img data-action="zoom" class="col-6 h-auto mb-2"');
      // value = value.replace(/(<img[^>]*>)([^<])/g, '$1<br />$2');
      value = value.replace(/(<img[^>]*>)/g, "$1<br />");
      return value;
    },
    clearfixParagraph: function(value) {
      value = value.replace(/<p/g, '<p class="clearfix"');
      return value;
    },
    addStyleTable: function(value) {
      value = value.replace(
        /<table/g,
        '<table class="table table-sm table-striped table-bordered"'
      );
      value = value.replace(
        /<th/g,
        '<th class="table-info text-center align-middle"'
      );
      value = value.replace(/<td/g, '<td class="text-center align-middle"');
      value = value.replace(
        /<table/g,
        '<div style="overflow: auto; white-space: nowrap;"><table'
      );
      value = value.replace(/<\/table>/g, "<table></div>");
      return value;
    },
    fixURLLink: function(value) {
      var regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
      var regexp_makeLink = function(all, url, h, href) {
        return '<a href="h' + href + '">' + url + "</a>";
      };
      value = value.replace(regexp_url, regexp_makeLink);
      return value;
    },
    fixParagraphText: function(value) {
      value = this.resizeImage(value);
      value = this.clearfixParagraph(value);
      value = this.addStyleTable(value);
      // value = this.fixURLLink(value);
      return value;
    },
  },
  head: {
    title: {
      // separator, complementは省略可能
      inner: "ブログ",
      separator: "|",
      complement: "たちかわ演劇祭",
    },
    meta: function() {
      const title = "ブログ | たちかわ演劇祭";
      const description =
        "たちかわ演劇祭のブログ。" +
        "たちかわ演劇祭は東京都立川市で毎年開催している演劇イベントです。" +
        "多摩地域で活躍している劇団と市民スタッフを中心として、" +
        "演劇を観る楽しさ、創る楽しさを多くの人に体験してもらう活動を続けています。";
      const keywords =
        "たちかわ演劇祭 立川演劇祭 立川 たちかわ 演劇 祭 " +
        "チケット 舞台 芝居 ミュージカル オペラ おすすめ たましん risuru リスル ホール";
      return [
        { name: "description", content: description },
        {
          name: "viewport",
          content: "width=device-width,initial-scale=1.0,user-scalable=no",
        },
        { charset: "utf-8" },
        { property: "og:type", content: "article" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { name: "description", content: description },
        { name: "keywords", content: keywords },
      ];
    },
  // head: {
    link: [
      // { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js@2.0.6/dist/zoom.css' },
      // { rel: 'stylesheet', href: 'https://raw.githubusercontent.com/fat/zoom.js/master/css/zoom.css' },
      { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom.css' },
      // { rel: 'shortcut icon', href: 'ファビコン' },
    ],
    script: [
      // { type: 'text/javascript', src: '外部jsファイル', async: true},
      // body内に挿入したい場合は「body: true」を入れましょう
      // { type: 'text/javascript', src: '外部jsファイル', async: true, body: true},
      // { type: 'text/javascript', src: 'https://cdn.jsdelivr.net/npm/zoom-vanilla.js/dist/zoom-vanilla.min.js', async: true, body: true},
    ],
  // },
  },
};
</script>

<style>
.paginate {
  padding: 15px 0px;
  width: 100%;
}
.pagination {
  justify-content: center;
}
</style>
